import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

export const CollapsibleGroup = ({ id, title, meta, image, children, action = null, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="border-b border-[#E6DAC5] last:border-b-0" data-testid={`group-${id}`}>
      <button type="button" onClick={() => setOpen((v) => !v)} aria-expanded={open} data-testid={`group-toggle-${id}`}
        className={`group w-full flex items-center gap-5 text-left ${action ? 'pt-6 pb-2' : 'py-6'}`}>
        {image && <img src={image} onError={(e) => { e.currentTarget.src = '/favicon-192.png'; }} alt="" className="w-14 h-14 rounded-xl object-cover flex-shrink-0" />}
        <div className="flex-1 min-w-0">
          <h3 className="font-display text-2xl md:text-3xl text-[#1E1622] group-hover:text-[#3B164C] transition-colors duration-200">{title}</h3>
          {meta && <p className="text-sm text-[#1E1622]/55 mt-1">{meta}</p>}
        </div>
        <span className={`w-10 h-10 rounded-full border border-[#E6DAC5] flex items-center justify-center text-[#3B164C] transition-transform duration-300 group-hover:border-[#C5A059] ${open ? 'rotate-180 bg-[#3B164C] text-white border-[#3B164C]' : ''}`}>
          <ChevronDown size={18} />
        </span>
      </button>
      {action && <div className={`pb-5 ${image ? 'pl-[76px]' : ''}`}>{action}</div>}
      <AnimatePresence initial={false}>
        {open && (
          <motion.div key="body" initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35 }} className="overflow-hidden" data-testid={`group-body-${id}`}>
            <div className="pb-10">{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export const SubHeading = ({ children, testId }) => (
  <p data-testid={testId} className="eyebrow mb-5 mt-2"><span className="w-10 h-px bg-[#C5A059]" /> {children}</p>
);
